import React from 'react';
import Image from 'next/image';
import { StyledImageContainer, AbsoluteWrapper, StyledContentWrapper } from './image.style';
import { useInView } from 'react-intersection-observer';

interface IBaseImageProps {
    imgUrl: string;
    isBackground: boolean;
    children?: React.ReactNode;
    placeholder: string;
    style?: React.CSSProperties;
    customContentStyle?: React.CSSProperties;
    lazy: boolean;
    priority?: boolean;
    fill?: boolean;
}
interface IBackgroundImage extends IBaseImageProps {
    isBackground: true;
    alt?: string;
    height?: number;
    width?: number;
}
interface IImageContainer extends IBaseImageProps {
    isBackground: false;
    alt: string;
    height?: number;
    width?: number;
    title?: string;
    containerHeight?: string;
    onLoad?: () => void;
}

export const NextImage = (props: IBackgroundImage | IImageContainer) => {
    const [ref, inView] = useInView({ triggerOnce: true, rootMargin: '100px' });
    const override = !process.browser ? true : !!window.IntersectionObserver;
    const blurStyle =
        override && props.lazy ? (inView ? { filter: 'blur(0px)' } : { filter: 'blur(7px)' }) : {};
    const url = props.lazy ? (inView ? props.imgUrl : props.placeholder) : props.imgUrl;
    const customStyles = {
        transition: 'filter 0.1s ease-in',
        width: '100%',
        height: '100%',
    };

    const imageLoader = ({ src }: any): string => {
        return src;
    };

    const sizeProps = {
        width: props.width || 800,
        height: props.height || 600,
    };
    const fillProps = { fill: props.fill };

    const fillOrSizeProps = props.fill ? fillProps : sizeProps;

    return props.isBackground ? (
        <>
            <div ref={ref} style={{ width: '100%', height: '100%', position: 'absolute' }}>
                {url && (
                    <Image
                        {...fillOrSizeProps}
                        loader={imageLoader}
                        alt={props.placeholder}
                        src={url}
                        style={{
                            ...blurStyle,
                            ...customStyles,
                            ...props.style,
                        }}
                        priority={props.priority}
                        quality={100}
                    />
                )}
            </div>
            <StyledContentWrapper style={{ ...props.customContentStyle }}>
                {props.children}
            </StyledContentWrapper>
        </>
    ) : (
        <StyledImageContainer ref={ref} height={props.containerHeight}>
            {url && (
                <Image
                    {...fillOrSizeProps}
                    loader={imageLoader}
                    alt={props.alt}
                    src={url}
                    style={{ ...blurStyle, ...customStyles, ...props.style }}
                    quality={100}
                    title={props.title}
                    onLoad={props.onLoad}
                />
            )}
            {props.children && (
                <AbsoluteWrapper style={props.style}>{props.children}</AbsoluteWrapper>
            )}
        </StyledImageContainer>
    );
};

NextImage.defaultProps = {
    lazy: false,
    isBackground: false,
    priority: false,
    containerHeight: '100%',
};
